"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRegHistorySelectionCriteria = void 0;
const mobx_1 = require("mobx");
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const get_search_query_1 = require("@App/helpers/get-search-query");
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
const registration_history_tab_name_1 = require("@App/enum/registration-history-tab-name");
const registration_history_tab_store_1 = __importDefault(require("@App/stores/rightsholder/registrationHistory/registration-history-tab-store"));
const generate_search_criterion_1 = require("@App/helpers/generate-search-criterion");
exports.defaultRegHistorySelectionCriteria = [
    (0, generate_search_criterion_1.generateSearchCriterionFromOption)(get_search_query_1.SEARCH_REG_HISTORY_WORK_OPTIONS[0], true),
];
class RegistrationHistoryStore {
    constructor(rootStore) {
        Object.defineProperty(this, "_registrationHistoryTabs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_criteriaStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                sort_by: 'last_update_date',
            }
        });
        (0, mobx_1.makeObservable)(this, {
            _criteriaStore: mobx_1.observable,
            _registrationHistoryTabs: mobx_1.observable,
            _currentQuery: mobx_1.observable,
            _currentFilters: mobx_1.observable,
            resetRegHistory: mobx_1.action,
            setCurrentQuery: mobx_1.action,
        });
        this._currentQuery = {};
        this._criteriaStore = this.createRegHistoryCriteriaStore();
        this._registrationHistoryTabs = this.createRegistrationHistoryTabs(rootStore);
    }
    get criteriaStore() {
        return this._criteriaStore;
    }
    get currentFilters() {
        return this._currentFilters;
    }
    setCurrentFilters(filters) {
        this._currentFilters = filters;
    }
    get tabNames() {
        return Object.keys(registration_history_tab_name_1.RegistrationHistoryTabName).map((key) => registration_history_tab_name_1.RegistrationHistoryTabName[key]);
    }
    get registrationHistoryTabs() {
        return this._registrationHistoryTabs;
    }
    get currentQuery() {
        return this._currentQuery;
    }
    setCurrentQuery(query) {
        this._currentQuery = query;
    }
    resetRegHistory() {
        this._currentQuery = {};
        this._criteriaStore = this.createRegHistoryCriteriaStore();
        this._registrationHistoryTabs.forEach((tab) => tab.resetStore());
    }
    createRegHistoryCriteriaStore() {
        const maxCriteria = 8;
        return new search_criteria_store_1.default(exports.defaultRegHistorySelectionCriteria, get_search_query_1.SEARCH_REG_HISTORY_WORK_OPTIONS, search_option_type_1.SearchOptionType.primary, required_criteria_1.RequiredCriteria.first, maxCriteria);
    }
    isCriteriaPresent() {
        return Object.values(this._criteriaStore.searchCriteria).some((criteria) => !!criteria.searchTerm && criteria.searchTerm !== '');
    }
    createRegistrationHistoryTabs(rootStore) {
        return new Map(this.tabNames.map((tab) => [tab, new registration_history_tab_store_1.default(rootStore)]));
    }
}
exports.default = RegistrationHistoryStore;
